import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SHEETS } from '../../ngrx/category-types';

@Injectable()
export class AuthSheetsGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const userData = localStorage.getItem('currentUser');
    const user = userData ? JSON.parse(userData) : null;
    
    if (!user) {
      this.router.navigate(['/pages/login']);
      return false;
    }

    const { team, role } = user;

    if (team !== SHEETS && role !== 'ADMIN') {
      return false;
    }

    return true;
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/guards/authSheets.guard.ts